<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Remitos</h1>
          <p class="view-header__subtitle">Gestioná los remitos de venta de la sucursal.</p>
        </div>
        <div class="view-header__actions">
          <router-link :to="nuevoRemitoDeVentaLink" class="btn view-header__btn view-header__btn--primary">
            <i class="bi bi-plus-lg"></i>
            Nuevo remito
          </router-link>
        </div>
      </div>
    </div>
    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar...">
          </div>
          <div class="filters-panel__field">
            <div class="form-check">
              <input id="oninvoiced" v-model="oninvoiced" class="form-check-input" type="checkbox">
              <label class="form-check-label" for="oninvoiced">Mostrar remitos ya facturados</label>
            </div>
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <Daterange ref="daterange" :opendir="'left'" :initial-start="dateRangeStart" :initial-end="dateRangeEnd" @datepicked="onDatePicked" />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn filters-panel__btn--outline" @click="clearFilters">
              <i class="bi bi-eraser"></i>
              Limpiar filtros
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @shippingNoteDetail="getShippingNoteDetail"
        @getPDF="downloadPDF"
        @saleFromSN="createSaleFromSN"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import { mapState } from 'vuex'
import Daterange from "../../global/Daterange-component.vue";
import formatDateMixin from "../../../mixins/formatDateMixin";
import myaxios from 'axios';


export default {
    components: {
      VdtnetTable,
      Daterange,
    },
    mixins: [formatDateMixin],
    data: function() {
      const defaultRange = this.last30DaysRange();
      return {
        doSearch: '',
        oninvoiced: false,
        isLoading: false,
        shippingNoteIdParent: null,
        dateRangeStart: defaultRange.startDate,
        dateRangeEnd: defaultRange.endDate,
        opts: {
        language: {
        url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        'ajax': {
          'url': process.env.VUE_APP_BASE_URL+"/api/shippingnotes/list",
          'data': (d) => {
            d.oninvoiced = this.oninvoiced,
            d.branchoffice_id = this.branchofficeId,
            d.daterange = this.daterange
          },
          'type': 'POST',
          'headers': { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
          },
          processing: false,
          pageLength: 15,
          searching: true,
          searchDelay: 1500,
          destroy: true,
          ordering: true,
          lengthChange: true,
          serverSide: true,
          fixedHeader: true,
          autoWidth: false,
        },
        fields: {
          id: { visible: false },
          number: { label: "N°", width: "70px" },
          created_at: {
            label: "Fecha",
            width: "120px",
            render: function(data) {
              return new Date(data).toLocaleDateString('es-AR')
            }
          },
          client: {
            label: "Cliente",
            render: (data, type) =>
              type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
          },
          user: { label: "Vendedor", width: "120px" },
          branchoffice: { label: "Sucursal", width: "120px" },
          actions: {
                isLocal: true,
                label: 'Acciones',
                width: "140px",
                align: 'right',
                defaultContent: `
                  <div class="table-action-group">
                    <button data-action="shippingNoteDetail" class="table-action-btn" type="button" title="Ver detalle">
                      <i class="bi bi-file-earmark-text"></i>
                    </button>
                    <button data-action="getPDF" class="table-action-btn" type="button" title="Descargar PDF">
                      <i class="bi bi-filetype-pdf"></i>
                    </button>
                    <button data-action="saleFromSN" class="table-action-btn" type="button" title="Crear venta asociada">
                      <i class="bi bi-basket"></i>
                    </button>
                  </div>
                `,
          },
        },
        shippingNotes: []
      }
    },
    computed: {
      daterange() {
        if (!this.dateRangeStart || !this.dateRangeEnd) return null;
        return `${this.formatoFecha2Daterange(this.dateRangeStart)} - ${this.formatoFecha2Daterange(this.dateRangeEnd)}`;
      },
      nuevoRemitoDeVentaLink() {
        return { name: 'Nuevo remito de venta' }
      },
      ...mapState('branchoffices',{
        branchofficeId: state => state.selectedBranchofficeId,
      }),
    },
    watch: {
      oninvoiced() {
        this.$refs.table.reload()
      },
      doSearch(newValue, oldValue) {
        if(newValue.length >= 4 || oldValue.length >= 4) {
          this.$refs.table.search(this.doSearch)
        }
        if(newValue === '' && oldValue.length > 0) {
          this.$refs.table.search(this.doSearch)
        }
      },
      branchofficeId () {
        this.refreshTable();
      },
      daterange () {
        this.refreshTable();
      },
    },
    mounted() {
      this.getShippingNotes();
      this.$nextTick(() => {
        const dt = this.$refs.table && this.$refs.table.dataTable;
        if (!dt) return;
        dt.on('preXhr.dt', () => { this.isLoading = true; });
        dt.on('xhr.dt', () => { this.isLoading = false; });
      });
    },
    methods: {
      refreshTable() {
        var vm = this;
        if (vm.$refs.table !== undefined) vm.$refs.table.reload();
        console.log(vm.$refs.table);
      },
      onDatePicked(date) {
        this.dateRangeStart = date.startDate;
        this.dateRangeEnd = date.endDate;
      },
      clearFilters() {
        this.doSearch = '';
        this.oninvoiced = false;
        const defaultRange = this.last30DaysRange();
        this.dateRangeStart = defaultRange.startDate;
        this.dateRangeEnd = defaultRange.endDate;
      },

      getShippingNotes() {
        var vm = this;
        vm.loading = true
          this.$http.post("/api/shippingnotes/list",{
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            },
            params:  {
              branchoffice_id : this.branchofficeId,
              oninvoiced: this.oninvoiced
            }
          }).then((response) => {
          vm.shippingNotes = response.data.data;
          vm.loading = false
        });
      },
      getShippingNoteDetail(data) {
        this.$router.push({name: 'Detalle de remito de venta', params: { shippingNoteId: data.id }})
      },
      createSaleFromSN(data) {
        this.$router.push({name: 'Nueva venta desde SN', params: { shippingNoteId: data.id }})
      },
      downloadPDF(data) {
        let id = data.id;
        let vm = this;
        let filename = data.client + data.created_at + '.pdf';
        console.log(filename);
        vm.loading = true
        axios.get("/api/shippingnotes/snPDF/"+id)
        .then((res) => {
          const uninterceptedAxiosInstance = myaxios.create();
          uninterceptedAxiosInstance.get(res.data, { responseType: 'blob' })
          .then((response) => {
            const blob = new Blob([response.data], {type: 'application/pdf'});
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = filename
            link.click()
            URL.revokeObjectURL(link.href)
          })
        })
      }
    }
  }
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 4px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}
</style>
